import api from 'ApiConfig';

const chatService = {
  // Student-side functions
  getStudentConversations: async (studentId) => {
    return api.get(`/chat/student/${studentId}`);
  },

  fetchUsersByRole: async (role) => {
    return api.get(`/chat/users/${role}`);
  },

  createOrGetConversation: async (studentId, recipientId, recipientRole) => {
    return api.post('/chat/conversation', {
      studentId,
      recipientId,
      recipientRole,
    });
  },

  getConversation: async (conversationId) => {
    return api.get(`/chat/conversation/${conversationId}`);
  },

  sendMessage: async (conversationId, content) => {
    return api.post('/chat/message', {
      conversationId,
      content,
    });
  },

  // Admin/Teacher-side functions
  getAllConversations: async () => {
    return api.get('/chat/user/all-conversations');
  },

  getUserConversations: async () => {
    return api.get('/chat/user/conversations');
  },

  getStudentsWithConversations: async () => {
    return api.get('/chat/user/students');
  },

  getConversationWithStudent: async (studentId) => {
    return api.get(`/chat/user/student/${studentId}`);
  },

  createOrGetStudentConversation: async (studentId) => {
    return api.post('/chat/user/conversation', {
      studentId,
    });
  },

  sendMessageToStudent: async (conversationId, content) => {
    return api.post('/chat/user/message', {
      conversationId,
      content,
    });
  },

  getAllStudents: async () => {
    return api.get('/chat/user/all-students');
  },

  getUnreadMessageCounts: async () => {
    return api.get('/chat/user/unread');
  },
  getSpecificConversation: async (conversationId) => {
    return api.get(`/chat/conversations/${conversationId}`);
  },
};

export default chatService;
